/**
 * Shared predicate used by every country/phone-code picker popup.
 *
 * Matches a country entry against a free-form search term:
 *   - by country name (case-insensitive substring)
 *   - by calling code digits (substring)
 *
 * Leading '+' in either the user's search term or the stored calling code is
 * stripped before comparison, so users can type "971", "+971", or "++971"
 * interchangeably — the backend sometimes returns codes with a leading '+'
 * and sometimes without.
 */
export const matchesCountryTerm = (
    entry: { label?: string; countryCallingCode: string },
    term: string,
): boolean => {
    const normalized = term.replace(/\+/g, "").toLowerCase();
    const code = entry.countryCallingCode.replace(/\+/g, "");
    const labelMatch = entry.label?.toLowerCase().includes(normalized) ?? false;
    return labelMatch || code.includes(normalized);
};
